module.exports = __webpack_public_path__ + "img/certification14.1655d1c5.png";